import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LanguageService } from './language.service'
import resource_en from '../../assets/json/i18n/en.json';
import resource_sc from '../../assets/json/i18n/zh-sc.json';
import resource_tc from '../../assets/json/i18n/zh-tc.json';

import { ToastController } from '@ionic/angular';

import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  json_en: any;
  json_sc: any;
  json_tc: any;

  private showLoadingCall = new Subject<any>();
  private showLoginForm = new Subject<any>();

  private GoToBookingCall = new Subject<any>();

  showLoadingCall$ = this.showLoadingCall.asObservable();
  showLoginFormCall$ = this.showLoginForm.asObservable();

  GoToBookingCall$ = this.GoToBookingCall.asObservable();

  showLoading(data: boolean) {
    this.showLoadingCall.next(data);
  }

  showLogin() {
    this.showLoginForm.next(true);
  }

  GoToBooking(){
    this.GoToBookingCall.next(true);
  }

  constructor(private languageService: LanguageService, private toastController: ToastController) {
    this.json_en = resource_en;
    this.json_sc = resource_sc;
    this.json_tc = resource_tc;
  }

  GetString(key: string): string {
    var result = null;

    var lang = this.languageService.getLang();
    if (lang == "en")
      result = this.json_en[key];
    else if (lang == "zh-sc")
      result = this.json_sc[key];
    else
      result = this.json_tc[key];

    if (!result)
      result = key;
    return result;
  }

  GetLang() {
    return this.languageService.getLang();
  }

  async openSnackBar(message: string) {
    message = this.GetString(message);
    const toast = await this.toastController.create({
      message: message,
      duration: 5000,
      position: 'top'
    });

    await toast.present();
  }

  async openExceptionSnackBar(ex: any) {
    var message = ex.error && ex.error.title ? this.GetString(ex.error.title) : this.GetString(ex.error) && ex.error.error ? this.GetString(ex.error.error) : this.GetString(ex.message);
    const toast = await this.toastController.create({
      message: message,
      duration: 5000,
      position: 'top',
      color: 'danger'
    });

    await toast.present();
  }

  async openFailSnackBar(message: string) {
    message = this.GetString(message);
    const toast = await this.toastController.create({
      message: message,
      duration: 5000,
      position: 'top',
      color: 'danger'
    });

    await toast.present();
  }

  ReturnDate(s) {
    console.log(s);
    console.log(moment.tz(s, "Asia/Hong_Kong").clone());
    return "";
  }

  DisplayDate(s) {
    //return moment.tz(s, moment.tz.guess()).format("DD/MM/YYYY");
    return moment.tz(s, "Asia/Hong_Kong").clone().tz(moment.tz.guess()).format("DD/MM/YYYY");
  }

  ToDate(s) {
    //return moment.tz(s, moment.tz.guess()).format("YYYY-MM-DD");
    return moment.tz(s, "Asia/Hong_Kong").clone().tz(moment.tz.guess()).format("YYYY-MM-DD");
  }

  DisplayTime(s) {
    return moment.tz(s, "Asia/Hong_Kong").clone().tz(moment.tz.guess()).format("HH:mm");
  }
}
